<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">      
      <v-row v-if="!isAgrupamento">
        <v-col>
          <input-v
            v-model="projeto.titulo_transmissao"
            :valid.sync="fieldsComputed.titulo_transmissao.valid"
            :label="fieldsComputed.titulo_transmissao"
            :editable="canEdit"
          >
          </input-v>
        </v-col>
      </v-row>
      <v-row class="mt-n2">
        <v-col :cols="isClient ? 12 : 3">
          <input-v
            v-model="projeto.id_projeto"
            :valid.sync="fieldsComputed.id_projeto.valid"
            :label="fieldsComputed.id_projeto"
            :editable="canEdit"
          >
          </input-v>
        </v-col>
        <v-col :cols="isClient ? 12 : 9">
          <input-v
            v-model="projeto.titulo"
            :valid.sync="fieldsComputed.titulo.valid"
            :label="fieldsComputed.titulo"
            :editable="canEdit"
          >
          </input-v>
        </v-col>
      </v-row>
      <v-row class="mt-n2 align-items-center">
        <v-col v-if="!isClient">
          <input-v
            v-model="projeto.trabalho"
            :valid.sync="fieldsComputed.trabalho.valid"
            :label="fieldsComputed.trabalho"
            :editable="canEdit && cliente.trabalho == 3"
            :opts="opts"
          >
          </input-v>
        </v-col>
        <v-col>
          <input-v
            v-model="projeto.status"
            :label="fieldsComputed.status"
            :editable="canEditStatus"
            :opts="opts"
          >
          </input-v>
        </v-col>      
        <div class="col">
          <input-v
            v-model="projeto.ano_base"
            :valid.sync="fieldsComputed.ano_base.valid"
            :label="fieldsComputed.ano_base"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col-auto" :lg="isClient || !hasAccessPlurianual ? 3 : 3" sm="12" xs="12">
          <button 
            style="background-color: #2a9af3; color: white; padding: 0.8rem; border-radius: 5px"
            @click="
              onPlurianualOpen();
              plurianualDialog = true;
            "
          >
            Gerar novo ano-base
          </button>
          <form-modal
            :cols="plurianualField"
            :maxWidth="plurianualDialogWidth"
            :opened.sync="plurianualDialog"
            :opts="opts"
            title="Gerar Outro Ano Base"
            :value.sync="plurianualData"
            @save="gerarProximoAnoBase($event)"
          ></form-modal>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import fields from '../LBEnquadrados.fields';
import { isStrictProject } from "@/helpers/projectValidators";
import { projectsOptions } from "@/helpers/yearsOptions";
import { FieldTypeEnum } from "@/core/enums/field-types";
import moment from "moment";
import { mapGetters } from "vuex";
import { BeneficiosLabels } from "@/core/enums/beneficios";

export default {
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    isAgrupamento: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'input-v': () => import('@/components/input-v.vue'),
    'form-modal': () => import('@/components/form-modal.vue'),
  },
  data() { 
    return {
      fields,
      plurianualDialog: false,
      plurianualData: {},
      projetosAgrupados: [],
    }
  },
  computed: {
    ...mapGetters(["clientId"]),
    plurianualField: function () {
      return [
        {
          key: "ano_base",
          name: "Gerar para o ano:",
          type: FieldTypeEnum.SELECT,
          rules: [{ rule: "required" }],
          rel: { toEdit: projectsOptions, id: "value", name: "text" },
          show: true,
          colSize: this.isAgrupamento ? 4 : 12,
        },
        {
          key: "projetos_agrupados",
          name: "Projetos desse agrupamento que serão replicadas junto do agrupamento",
          placeholder:
            "Nenhum projeto selecionado, agrupamento sera replicado vazio",
          type: FieldTypeEnum.AUTOCOMPLETE_MULTIPLE,
          rel: { to: this.projetosAgrupados, key: "id", name: "titulo" },
          show: this.isAgrupamento,
          colSize: 12,
        },
      ].filter(({ show }) => show);
    },
    plurianualDialogWidth: function () {
      return this.isAgrupamento ? "60%" : "20%";
    },
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.escopo);
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (!isStrict) {
             field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
  },
  methods: {
    onPlurianualOpen: function () {
      this.plurianualData = {
        projetos_agrupados: this.isAgrupamento
          ? this.projeto.projetos_agrupados.map(({ id }) => id)
          : undefined,
      };
      if (this.isAgrupamento) {
         this.projetosAgrupados = this.formatProjetosOptions(
            this.projeto.projetos_agrupados
          );
      }
    },
    gerarProximoAnoBase: function ({ ano_base, projetos_agrupados }) {
      const dataFimProjeto = this.projeto.data_fim;
      const dataAnoBase = moment(dataFimProjeto).get("year");
      if (dataFimProjeto && dataAnoBase < ano_base) {
        const dataFimExibicao = moment(dataFimProjeto).format("DD/MM/YYYY");
        this.showConfirm(
          `Projeto encerrado em ${dataFimExibicao}`,
          `Deseja prosseguir com a replicação do projeto para o ano ${ano_base}? O novo projeto será criado com data fim indefinida.`,
          () => {
            this.gerarAnoBase(ano_base, projetos_agrupados);
          }
        );
      } else {
        this.gerarAnoBase(ano_base, projetos_agrupados);
      }
    },
    gerarAnoBase: function (ano_base, projetos_agrupados) {
      this.apiResource(
        `v1/projetos/${this.clientId}/plurianual/${this.projeto.id}`
      )
        .save({ ano_base, projetos_agrupados })
        .then((response) => {
          if (response.error) {
            return;
          }

          this.plurianualDialog = false;
          const route = this.$router.resolve({
            name: "ficha-projeto-enquadrado",
            params: { projetoId: response.id },
          });
          window.open(route.href, "_blank");
        });
    },
    formatProjetosOptions: function (projetos) {
      if (!Array.isArray(projetos)) {
        return [];
      }

      return projetos
        .map((projeto) => {
          const trabalho =
            BeneficiosLabels[projeto.trabalho] || "Sem Benefício";
          const titulo = `${
            projeto.titulo || "Título não encontrado"
          } [${trabalho}]`;
          const disabled = this.projeto.trabalho != projeto.trabalho;
          return { ...projeto, disabled, titulo };
        })
        .sort((a, b) => {
          const { titulo: tituloA, trabalho: trabalhoA } = a;
          const { titulo: tituloB, trabalho: trabalhoB } = b;
          const disabledA = a.disabled ? 1 : 0;
          const disabledB = b.disabled ? 1 : 0;
          return (
            disabledA - disabledB ||
            trabalhoA - trabalhoB ||
            tituloA.localeCompare(tituloB)
          );
        });
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
.custom-input:focus {
  border-color: #1C1C44; 
  box-shadow: 0 0 0 0.2rem rgba(40, 42, 167, 0.25);
  outline: none
}
.custom-input {
  border-color: #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
</style>